import moment from "moment";
import {configNo, configNumber} from "../config";
import React from 'react'

export const configHeaderTeamLeader = [
    {name: "employeeName", label: "Nama Team Leader", options: {sort: false}},
];

export const configHeaderSalesman = [
    { name: "salesName", label: "Nama Sales/CS", options: { sort: false } },
];

function getDaysInMonth(year, month) {
  const date = moment({
    year: year !== undefined ? year : moment().year(),
    month: month !== undefined ? month - 1 : moment().month(),
  });

  return date.daysInMonth();
}

export const getConfigDaily = (month, year) => {
    const currentTotalMonth = getDaysInMonth(year, month);
    const daysArray = Array.from({ length: currentTotalMonth }, (_, i) => ({
      name: String(i + 1),
      label: i + 1,
      options: { sort: false },
    }));
    return [
      ...daysArray,
      {
        name: "total",
        label: "Total",
        options: { sort: false },
      },
      {
        name: "target",
        label: "Target",
        options: { sort: false },
      },
      {
        name: "achievement",
        label: "%achv",
        options: { sort: false },
      },
      {
        name: "projection",
        label: "Proyeksi",
        options: { sort: false },
      },
    ];
}

export const configDailySalesLeasingAdditional = (leasingName) => [
    { name: `${leasingName}Daily`, label: `Harian ${leasingName}`, options: { sort: false } },
    { name: `${leasingName}Accumulation`, label: `Akumulasi ${leasingName}`, options: { sort: false } },
    { name: `${leasingName}mscp`, label: `$mscp ${leasingName}`, options: { sort: false } },
];

export const configDailySalesLeasing = [
    ...configNo,
    { name: "date", label: "Tanggal", options: { sort: false } },
    { name: "dailyCash", label: "Cash\nHarian", options: { sort: false } },
    { name: "accumulateCash", label: "Cash\nAkumulasi", options: { sort: false } },
    { name: "spCash", label: "Cash\n%sp", options: { sort: false } },
    { name: "dailyKDS", label: "KDS\nHarian", options: { sort: false } },
    { name: "accumulateKDS", label: "KDS\nAkumulasi", options: { sort: false } },
    { name: "spKDS", label: "KDS\n%sp", options: { sort: false } },
    { name: "dailyCredit", label: "Kredit\nHarian", options: { sort: false } },
    { name: "spCredit", label: "Kredit\n%sp", options: { sort: false } },
    { name: "accumulateCredit", label: "Kredit\nAkumulasi", options: { sort: false } },
    { name: "dailyTotal", label: "Total\nHarian", options: { sort: false } },
    { name: "accumulateTotal", label: "Total\nAkumulasi", options: { sort: false } },
];

export const configMonthToDateLeasing = [
    {name: "displayName", label: "Nama Leasing", options: {sort: false}},
    {name: "lastMonth", label: "Last Month", options: {sort: false,}},
    {name: "thisMonth", label: "This Month", options: {sort: false,}},
    {name: "growth", label: "Growth", options: {sort: false,}},
    {name: "projection", label: "Proyeksi", options: {sort: false,}},
];

export const configMonthToDatePayment = [
    {name: "displayName", label: "Jenis Pembayaran", options: {sort: false}},
    {name: "lastMonth", label: "Last Month", options: {sort: false,}},
    {name: "thisMonth", label: "This Month", options: {sort: false,}},
    {name: "growth", label: "Growth", options: {sort: false,}},
    {name: "projection", label: "Proyeksi", options: {sort: false,}},
];

export const configMonthToDateSalesman = [
    {
        name: "no",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                if(tableMeta?.rowData[1] === "Total"){
                  return null
                }

                // Kalau ada, tetap hitung berdasarkan index
                const { page, rowsPerPage } = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;
                return <>{rowNumber}</>;
            },
        },
    },
    {name: "name", label: "Nama Sales/CS", options: {sort: false}},
    {name: "lastMonth", label: "Last Month", options: {sort: false,}},
    {name: "thisMonth", label: "This Month", options: {sort: false,}},
    {name: "growth", label: "Growth", options: {sort: false,}},
    {name: "forecasting", label: "Proyeksi", options: {sort: false,}},
];

export const configYearToDatePayment = (year)=>[
    ...configNo,
    { name: "paymentName", label: "Jenis Pembayaran", options: { sort: false } },
    { name: "january", label: "JAN", options: { sort: false } },
    { name: "february", label: "FEB", options: { sort: false } },
    { name: "march", label: "MAR", options: { sort: false } },
    { name: "april", label: "APR", options: { sort: false } },
    { name: "may", label: "MAY", options: { sort: false } },
    { name: "june", label: "JUN", options: { sort: false } },
    { name: "july", label: "JUL", options: { sort: false } },
    { name: "august", label: "AUG", options: { sort: false } },
    { name: "september", label: "SEP", options: { sort: false } },
    { name: "october", label: "OCT", options: { sort: false } },
    { name: "november", label: "NOV", options: { sort: false } },
    { name: "december", label: "DEC", options: { sort: false } },
    { name: "yearToDateTotal", label: year || moment().format("YYYY"), options: { sort: false } },
];

export const configYearToDateLeasing = (year) => [
    ...configNo,
    { name: "paymentName", label: "Nama Leasing", options: { sort: false } },
    { name: "january", label: "JAN", options: { sort: false } },
    { name: "february", label: "FEB", options: { sort: false } },
    { name: "march", label: "MAR", options: { sort: false } },
    { name: "april", label: "APR", options: { sort: false } },
    { name: "may", label: "MAY", options: { sort: false } },
    { name: "june", label: "JUN", options: { sort: false } },
    { name: "july", label: "JUL", options: { sort: false } },
    { name: "august", label: "AUG", options: { sort: false } },
    { name: "september", label: "SEP", options: { sort: false } },
    { name: "october", label: "OCT", options: { sort: false } },
    { name: "november", label: "NOV", options: { sort: false } },
    { name: "december", label: "DEC", options: { sort: false } },
    { name: "yearToDateTotal", label: year || moment().format("YYYY"), options: { sort: false } },
];

export const configLast3YearsTeamLeader = (val) => {
  const year = val ? Number(val) : Number(moment().format("YYYY"))
  return [
      ...configNo,
      { name: "name", label: "Nama Tim Leader", options: { sort: false } },
      { name: "year2Quartal1", label: `Q1 ${year - 2}`, options: { sort: false } },
      { name: "year2Quartal2", label: `Q2 ${year - 2}`, options: { sort: false } },
      { name: "year2Quartal3", label: `Q3 ${year - 2}`, options: { sort: false } },
      { name: "year2Quartal4", label: `Q4 ${year - 2}`, options: { sort: false } },
      { name: "year1Quartal1", label: `Q1 ${year - 1}`, options: { sort: false } },
      { name: "year1Quartal2", label: `Q2 ${year - 1}`, options: { sort: false } },
      { name: "year1Quartal3", label: `Q3 ${year - 1}`, options: { sort: false } },
      { name: "year1Quartal4", label: `Q4 ${year - 1}`, options: { sort: false } },
      { name: "yearQuartal1", label: `Q1 ${year}`, options: { sort: false } },
      { name: "yearQuartal2", label: `Q2 ${year}`, options: { sort: false } },
      { name: "yearQuartal3", label: `Q3 ${year}`, options: { sort: false } },
      { name: "yearQuartal4", label: `Q4 ${year}`, options: { sort: false } },
  ]
};

export const configLast3YearsSalesman = (val) => {
  const year = val ? Number(val) : Number(moment().format("YYYY"))

  return [
      ...configNo,
      { name: "name", label: "Nama Sales/CS", options: { sort: false } },
      { name: "year2Quartal1", label: `Q1 ${year - 2}`, options: { sort: false } },
      { name: "year2Quartal2", label: `Q2 ${year - 2}`, options: { sort: false } },
      { name: "year2Quartal3", label: `Q3 ${year - 2}`, options: { sort: false } },
      { name: "year2Quartal4", label: `Q4 ${year - 2}`, options: { sort: false } },
      { name: "year1Quartal1", label: `Q1 ${year - 1}`, options: { sort: false } },
      { name: "year1Quartal2", label: `Q2 ${year - 1}`, options: { sort: false } },
      { name: "year1Quartal3", label: `Q3 ${year - 1}`, options: { sort: false } },
      { name: "year1Quartal4", label: `Q4 ${year - 1}`, options: { sort: false } },
      { name: "yearQuartal1", label: `Q1 ${year}`, options: { sort: false } },
      { name: "yearQuartal2", label: `Q2 ${year}`, options: { sort: false } },
      { name: "yearQuartal3", label: `Q3 ${year}`, options: { sort: false } },
      { name: "yearQuartal4", label: `Q4 ${year}`, options: { sort: false } },
  ]
};

export const configVariantSales = [
    ...configNo,
    { name: "segmen", label: "Segmen", options: { sort: false } },
    { name: "kodeVarian", label: "Kode Varian", options: { sort: false } },
    { name: "namaVarian", label: "Nama Varian", options: { sort: false } },
    { name: "totalLastMonth", label: "Total\nLast Month", options: { sort: false } },
    { name: "totalThisMonth", label: "Total\nThis Month", options: { sort: false } },
    { name: "totalGrowth", label: "Growth", options: { sort: false } },
    { name: "cashLastMonth", label: "Cash\nLast Month", options: { sort: false } },
    { name: "cashThisMonth", label: "Cash\nThis Month", options: { sort: false } },
    { name: "cashGrowth", label: "Growth", options: { sort: false } },
    { name: "creditLastMonth", label: "Credit\nLast Month", options: { sort: false } },
    { name: "creditThisMonth", label: "Credit\nThis Month", options: { sort: false } },
    { name: "creditGrowth", label: "Growth", options: { sort: false } },
];

export const configVariantSalesYearToDate = (year) => [
    ...configNo,
    { name: "segmen", label: "Segmen", options: { sort: false } },
    { name: "kodeVarian", label: "Kode Varian", options: { sort: false } },
    { name: "namaVarian", label: "Nama Varian", options: { sort: false } },
    { name: "jan", label: "JAN", options: { sort: false } },
    { name: "feb", label: "FEB", options: { sort: false } },
    { name: "mar", label: "MAR", options: { sort: false } },
    { name: "apr", label: "APR", options: { sort: false } },
    { name: "may", label: "MAY", options: { sort: false } },
    { name: "jun", label: "JUN", options: { sort: false } },
    { name: "jul", label: "JUL", options: { sort: false } },
    { name: "aug", label: "AUG", options: { sort: false } },
    { name: "sep", label: "SEP", options: { sort: false } },
    { name: "oct", label: "OCT", options: { sort: false } },
    { name: "nov", label: "NOV", options: { sort: false } },
    { name: "dec", label: "DEC", options: { sort: false } },
    { name: "yearToDate", label: year || moment().format("YYYY"), options: { sort: false } },
];

export const transformResponseLastThreeYearsToTable = (val) => {
    const data = val.dataSales.map((item, index) => ({
        no: index + 1,
        name: item.name,
        year2Quartal1: item.quartal.year2Quartal1,
        year2Quartal2: item.quartal.year2Quartal2,
        year2Quartal3: item.quartal.year2Quartal3,
        year2Quartal4: item.quartal.year2Quartal4,
        year1Quartal1: item.quartal.year1Quartal1,
        year1Quartal2: item.quartal.year1Quartal2,
        year1Quartal3: item.quartal.year1Quartal3,
        year1Quartal4: item.quartal.year1Quartal4,
        yearQuartal1: item.quartal.yearQuartal1,
        yearQuartal2: item.quartal.yearQuartal2,
        yearQuartal3: item.quartal.yearQuartal3,
        yearQuartal4: item.quartal.yearQuartal4
    }));

    data.push({
        no: "",
        name: "TOTAL",
        year2Quartal1: val.totalYearMinus2q1,
        year2Quartal2: val.totalYearMinus2q2,
        year2Quartal3: val.totalYearMinus2q3,
        year2Quartal4: val.totalYearMinus2q4,
        year1Quartal1: val.totalYearMinus1q1,
        year1Quartal2: val.totalYearMinus1q2,
        year1Quartal3: val.totalYearMinus1q3,
        year1Quartal4: val.totalYearMinus1q4,
        yearQuartal1: val.totalThisYearq1,
        yearQuartal2: val.totalThisYearq2,
        yearQuartal3: val.totalThisYearq3,
        yearQuartal4: val.totalThisYearq4,
    });

    return data;
}

export const transformResponseYearsToDateToTablePayment = (val) => {
    const result = [];

    // Payment Group1
    const group1 = val.paymentGroup1.map((item, index) => ({
        no: index + 1,
        paymentName: item.paymentName,
        ...item.data,
        yearToDateTotal: item.yearToDateTotal
    }));
    result.push(...group1);

    // Total Group 1
    result.push({
        paymentName: "Total",
        january: val.paymentTotalGroup1.totalPaymentPerGroup.january,
        february: val.paymentTotalGroup1.totalPaymentPerGroup.february,
        march: val.paymentTotalGroup1.totalPaymentPerGroup.march,
        april: val.paymentTotalGroup1.totalPaymentPerGroup.april,
        may: val.paymentTotalGroup1.totalPaymentPerGroup.may,
        june: val.paymentTotalGroup1.totalPaymentPerGroup.june,
        july: val.paymentTotalGroup1.totalPaymentPerGroup.july,
        august: val.paymentTotalGroup1.totalPaymentPerGroup.august,
        september: val.paymentTotalGroup1.totalPaymentPerGroup.september,
        october: val.paymentTotalGroup1.totalPaymentPerGroup.october,
        november: val.paymentTotalGroup1.totalPaymentPerGroup.november,
        december: val.paymentTotalGroup1.totalPaymentPerGroup.december,
        yearToDateTotal: val.paymentTotalGroup1.allTotalPayment
    });

    return result;
}

export const transformResponseYearsToDateToTableLeasing = (val) => {
    const result = [];

    // Payment Group2 
    const group2 = val.paymentGroup2.map((item, index) => ({
        no: index + 1,
        paymentName: item.paymentName,
        ...item.data,
        yearToDateTotal: item.yearToDateTotal
    }));

    result.push(...group2);

    // Total Group 2 
    result.push({
        paymentName: "TOTAL",
        january: val.paymentTotalGroup2.totalPaymentPerGroup.january,
        february: val.paymentTotalGroup2.totalPaymentPerGroup.february,
        march: val.paymentTotalGroup2.totalPaymentPerGroup.march,
        april: val.paymentTotalGroup2.totalPaymentPerGroup.april,
        may: val.paymentTotalGroup2.totalPaymentPerGroup.may,
        june: val.paymentTotalGroup2.totalPaymentPerGroup.june,
        july: val.paymentTotalGroup2.totalPaymentPerGroup.july,
        august: val.paymentTotalGroup2.totalPaymentPerGroup.august,
        september: val.paymentTotalGroup2.totalPaymentPerGroup.september,
        october: val.paymentTotalGroup2.totalPaymentPerGroup.october,
        november: val.paymentTotalGroup2.totalPaymentPerGroup.november,
        december: val.paymentTotalGroup2.totalPaymentPerGroup.december,
        yearToDateTotal: val.paymentTotalGroup2.allTotalPayment
    });

    return result;
}

const SPACER_DATA = {
  leasingName: "",
  lastMonth: null,
  thisMonth: null,
  growth: null,
  projection: null,
};


export const transformResponseMTD = (data) => {
  if (!data) return [];

  const {
    dataLeasing = [],
    dataNonLeasing = [],
    dataTotalLeasing = {},
    dataTotalNonLeasing = {},
  } = data;

  const formatPercent = (value) =>
    value !== null && value !== undefined ? `${value}%` : "-";

  // Proses data leasing
  const combinedLeasing = [
    ...dataLeasing.map(item => ({
      ...item,
      displayName: item.leasingName,
    })),
    {
      displayName: "Total Leasing",
      lastMonth: dataTotalLeasing.totalLastMonth,
      thisMonth: dataTotalLeasing.totalThisMonth,
      growth: dataTotalLeasing.totalGrowth,
      projection: dataTotalLeasing.totalProjection,
    },
  ];

  // Proses data non-leasing
  const combinedNonLeasing = [
    ...dataNonLeasing.map(item => ({
      ...item,
      displayName: item.paymentMethod,
      // growth: formatPercent(item.growth)
    })),
    {
      displayName: "Total",
      lastMonth: dataTotalNonLeasing.totalLastMonth,
      thisMonth: dataTotalNonLeasing.totalThisMonth,
      growth: dataTotalNonLeasing.totalGrowth,
      projection: dataTotalNonLeasing.totalProjection,
    },
  ];

  // Gabungkan hasil
  return [...combinedNonLeasing, SPACER_DATA, ...combinedLeasing];
};